import { createRouter, createWebHistory } from 'vue-router';
import HomeLayout from '../layouts/HomeLayout.vue';
import NoteHome from '../views/NoteHome.vue';
import NoteMain from '../views/NoteMain.vue';
import Other from '../views/Other.vue';
import NotFound from '../views/NotFound.vue';

const router = createRouter({
  // 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: createWebHistory(),
  routes: [
    {
      path: '',
      name: 'home',
      component: HomeLayout,
      meta: { keepAlive: true },
      children: [
        {
          path: '/',
          alias: '',
          component: NoteHome,
          name: 'NoteHome',
          meta: { keepAlive: true }
        }
      ]
    },
    {
      path: '/article',
      name: 'article',
      component: HomeLayout,
      meta: { keepAlive: true },
      children: [
        {
          path: '/article/:id',
          component: NoteMain,
          name: 'NoteArticle',
          meta: { keepAlive: true }
        }
      ]
    },
    {
      component: HomeLayout,
      children: [
        {
          path: '/admin/noteadd',
          component: () => import('@/views/NoteAmend.vue'),
          name: 'ArticleAdd',
          meta: { isAdmin: true }
        }
      ]
    },
    {
      component: HomeLayout,
      children: [
        {
          path: '/admin/noteedit/:id',
          component: () => import('@/views/NoteAmend.vue'),
          name: 'ArticleEdit',
          meta: { isAdmin: true }
        }
      ]
    },
    {
      component: HomeLayout,
      children: [
        {
          path: '/:section(section_\\d+)/:id(\\w+)?',
          component: NoteMain,
          name: 'NoteMain',
          meta: { hasSide: true }
        }
      ]
    },
    {
      component: HomeLayout,
      children: [
        {
          path: '/mine/profile',
          alias: '/mine',
          name: 'mine_profile',
          component: () => import('@/views/mine/Profile.vue')
        }
      ]
    },
    {
      path: '/other',
      component: HomeLayout,
      children: [
        {
          path: '/other/',
          component: Other,
          name: 'other'
        }
      ]
    },
    {
      // 其它没有匹配到的路由都会跳至此模块(404）
      // 该路由为必须路由，不需要权限，必须放在最后
      path: '/:pathMatch(.*)',
      name: 'notfound',
      component: NotFound,
      meta: { keepAlive: false }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // console.log('to', to, 'from:', from);
  if (
    to.params &&
    to.params.section &&
    from.params &&
    from.params.section &&
    to.params.section === from.params.section &&
    !to.params.id
  ) {
    return;
  }
  // const store = useUserStore();
  // if (to.path === '/' || to.path.startsWith('/home')) {
  //   next();
  // } else {
  //   if (!store.account) {
  //     next({ path: '/' });
  //     store.showLogin = true;
  //   } else {
  //     next();
  //   }
  // }
  next();
});

export default router;
